import { render, staticRenderFns } from "./Vessel.vue?vue&type=template&id=27d9c998&scoped=true&"
import script from "./Vessel.vue?vue&type=script&lang=ts&"
export * from "./Vessel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d9c998",
  null
  
)

export default component.exports